export const SESSION_STORAGE_KEY_PINTEREST_CLICK_ID = "pinterestClickId";
